<template>
  <div class="ol-actions-tabs-wrap">
    <div class="ol-actions-tabs" role="tablist">
      <button
        v-if="showNoteTab"
        type="button"
        role="tab"
        class="ol-actions-tabs__btn"
        :class="{ 'ol-actions-tabs__btn--active': activeTab === 'note' }"
        :aria-selected="activeTab === 'note'"
        @click="selectTab('note')"
      >
        {{ $t("lang.opportunities.tab_note") }}
      </button>
      <button
        v-if="showEmailTab"
        type="button"
        role="tab"
        class="ol-actions-tabs__btn"
        :class="{ 'ol-actions-tabs__btn--active': activeTab === 'email' }"
        :aria-selected="activeTab === 'email'"
        @click="selectTab('email')"
      >
        {{ $t("lang.button.answerviaoliver") }}
      </button>
      <button
        v-if="showReminderTab"
        type="button"
        role="tab"
        class="ol-actions-tabs__btn"
        :class="{ 'ol-actions-tabs__btn--active': activeTab === 'reminder' }"
        :aria-selected="activeTab === 'reminder'"
        @click="selectTab('reminder')"
      >
        {{ $t("lang.opportunities.reminder") }}
      </button>
      <button
        v-if="hasEvent"
        type="button"
        role="tab"
        class="ol-actions-tabs__btn"
        :class="{ 'ol-actions-tabs__btn--active': activeTab === 'replan' }"
        :aria-selected="activeTab === 'replan'"
        @click="selectTab('replan')"
      >
        {{ $t("lang.opportunities.replanify_rdv") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "note",
    },
    fromAdminTasks: {
      type: Boolean,
      default: false,
    },
    permissionFront: {
      type: Boolean,
      default: false,
    },
    hasEvent: {
      type: Boolean,
      default: true,
    },
    isOnlyBilling: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    activeTab: {
      get() {
        return this.value;
      },
      set(tab) {
        this.$emit("input", tab);
      },
    },
    showNoteTab() {
      return !this.isOnlyBilling || this.permissionFront;
    },
    showEmailTab() {
      return !this.isOnlyBilling || this.permissionFront;
    },
    showReminderTab() {
      return !this.fromAdminTasks && this.permissionFront;
    },
    visibleTabs() {
      const tabs = [];
      if (this.showNoteTab) tabs.push("note");
      if (this.showEmailTab) tabs.push("email");
      if (this.showReminderTab) tabs.push("reminder");
      if (this.hasEvent) tabs.push("replan");
      return tabs;
    },
  },

  watch: {
    visibleTabs: {
      immediate: true,
      handler(tabs) {
        if (tabs.length && tabs.indexOf(this.activeTab) === -1) {
          this.activeTab = tabs[0];
        }
      },
    },
  },

  methods: {
    selectTab(tab) {
      if (this.activeTab === tab) {
        if (tab === "email") {
          this.$emit("emailSelected");
        }
        return;
      }
      this.activeTab = tab;
      if (tab === "email") {
        this.$emit("emailSelected");
      }
    },
  },
};
</script>

<style scoped>
.ol-actions-tabs-wrap {
  padding: 14px 1.25rem 0;
  border-bottom: 1px solid #f4f4f7;
}

.ol-actions-tabs {
  display: flex;
  gap: 4px;
  background: #f4f4f7;
  padding: 3px;
  border-radius: 9px;
  width: fit-content;
  max-width: 100%;
  flex-wrap: wrap;
}

.ol-actions-tabs__btn {
  display: flex;
  align-items: center;
  background: transparent;
  border: none;
  padding: 7px 14px;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  line-height: 1.2;
  white-space: nowrap;
}

.ol-actions-tabs__btn--active {
  background: white;
  color: #4b4be1;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.ol-actions-tabs__btn:focus {
  outline: none;
}
</style>
